import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

//Carousel
import Carousel from "react-bootstrap/Carousel";

//logo
import logo1 from "./assete/moxtalef/logo1.png";
import logo2 from "./assete/moxtalef/logo2.png";
import logo3 from "./assete/moxtalef/logo3.png";
import logo4 from "./assete/moxtalef/logo4.png";
//photo
import pic1 from "./assete/moxtalef/pic1.png";
import pic2 from "./assete/moxtalef/pic2.png";
import pic3 from "./assete/moxtalef/pic3.png";
const Moxtalef = () => {
  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "space-between",
              margin: "20px 0px",
            }}
          >
            <img src={logo4} alt="Logo" style={{ width: "12%" }}></img>
            <img src={logo2} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo3} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم مانیتورینگ ، ثبت اطلاعات و گزارش گیری
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>
                1500 پارامتر دستگاه{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  TBM
                </span>{" "}
                خط1 قطار شهری تبریز و حومه{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  TURO
                </span>
              </li>
              <li>پرس های پخت ناحیه 4 کارخانه لاستیک بارز</li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم کنترل و مانیتورینگ
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>دستگاه هونینگ موتورسازان تراکتورسازی</li>
              <li>
                {" "}
                دستگاه{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  ERNEST Thielenhouse Microfinishing
                </span>{" "}
                بلبرینگ سازی
              </li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div">
            <Carousel style={{ width: "100%", float: "left" }}>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Moxtalef;
